import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/utils';

interface PanelProps extends HTMLAttributes<HTMLDivElement> {
  level?: 1 | 2;
  bracket?: boolean;
  children: ReactNode;
}

/**
 * HUD-style panel container (v2 layout grammar, warna skema asli RJ TRACK).
 * - Level 1: bg-bg-secondary (#0f1424)
 * - Level 2: bg-bg-tertiary (#161b2e)
 * - Border: 1px rgba(0,255,225,0.18), radius 4px
 * - Bracket: garis L cyan/40 di sudut atas saat true
 */
export function Panel({ level = 1, bracket = true, className, children, ...props }: PanelProps) {
  const bgColor = level === 1 ? 'bg-bg-secondary' : 'bg-bg-tertiary';

  return (
    <div
      className={cn(
        'relative w-full border border-[rgba(0,255,225,0.18)] rounded-[4px]',
        bgColor,
        className,
      )}
      {...props}
    >
      {bracket && (
        <>
          <span
            aria-hidden
            className="absolute top-0 left-0 w-2 h-2 border-t border-l border-neon-cyan/40 pointer-events-none"
          />
          <span
            aria-hidden
            className="absolute top-0 right-0 w-2 h-2 border-t border-r border-neon-cyan/40 pointer-events-none"
          />
        </>
      )}

      <div className="relative z-10">{children}</div>
    </div>
  );
}
